module.exports = __webpack_public_path__ + "img/hz_31.dd6912f4.jpg";